module.exports = __webpack_public_path__ + "static/media/ycmsfy.2a5581dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/ycmsfy.png
// module id = 451
// module chunks = 0